import { BASE_URL, getFetchHttpOptions } from "src/util/appConfig";
import { saveItem } from "src/services/sessionStorage";

import {
  HOME_REALM_SESSION_KEY,
  hasUsableHomeRealmConfig,
  shouldFetchHomeRealmDiscovery,
} from "./homeRealmDiscoveryConfig";

/** @type {Promise<object | null> | null} */
let inFlight = null;

/**
 * Start home-realm-discovery as early as possible (before React commit) so it
 * overlaps JS parse/eval. Safe to call multiple times; returns the same promise.
 */
export const startHomeRealmDiscoveryPrefetch = () => {
  if (inFlight || !shouldFetchHomeRealmDiscovery()) {
    return inFlight;
  }

  inFlight = fetch(
    `${BASE_URL}/functions/home-realm-discovery`,
    getFetchHttpOptions()
  )
    .then((response) => response.json())
    .then((data) => {
      if (!hasUsableHomeRealmConfig(data)) {
        inFlight = null;
        return null;
      }
      saveItem(HOME_REALM_SESSION_KEY, data);
      return data;
    })
    .catch(() => {
      inFlight = null;
      return null;
    });

  return inFlight;
};

/** @returns {Promise<object | null> | null} */
export const getHomeRealmDiscoveryPrefetch = () => inFlight;

/** @internal test helper */
export const resetHomeRealmDiscoveryPrefetchForTests = () => {
  inFlight = null;
};
